<template>
  <span>
    <h3 class="ma-0 pa-0">Family History</h3>
    <v-row>
      <v-col cols="12" md="6" lg="6" xl="6">
        <!-- Relationship -->
        <v-text-field
          v-model="family.relationship"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Relationship</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="6" xl="6">
        <!-- Health Condition -->
        <v-text-field
          v-model="family.health"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Health Condition</span>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <div class="d-flex justify-center mb-5">
      <!-- Add To List Button -->
      <v-btn
        depressed
        rounded
        small
        color="primary"
        @click="addRelative"
        :disabled="!family.name || !family.relationship || !family.health"
      >
        Add to list
      </v-btn>
    </div>

    <h3 class="ma-0 pa-0">List</h3>
    <table>
      <thead>
        <tr>
          <th style="width: 25%">Relationship</th>
          <th style="width: 40%">Health Condition</th>
          <th style="width: 15%">Options</th>
        </tr>
      </thead>
      <tbody v-if="relatives.length">
        <tr v-for="(relative, key) in relatives" :key="key">
          <td style="width: 25%">{{ relative.relationship }}</td>
          <td style="width: 40%">{{ relative.health }}</td>
          <td style="width: 15%">
            <span class="clickable" @click="editRelative(key)"> Edit </span>
            <span
              class="ml-5 red--text text--lighten-2 clickable"
              @click="removeRelative(key)"
            >
              Delete
            </span>
          </td>
        </tr>
      </tbody>
      <!-- Empty Table -->
      <div
        v-else
        class="d-flex justify-center align-center w-100"
        style="min-height: 100px"
      >
        <span>No data available</span>
      </div>
    </table>
  </span>
</template>

<script>
export default {
  props: {
    relatives: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => ({
    // relatives: [],
    family: {
      health: "",
      relationship: "",
    },
  }),
  methods: {
    addRelative() {
      let relative = { ...this.family };
      this.relatives.splice(0, 0, relative);

      this.family = {
        relationship: "",
        health: "",
      };
    },
    editRelative(index) {
      let relative = this.relatives[index];

      this.family = {
        relationship: relative.relationship,
        health: relative.health,
      };

      this.removeRelative(index);
    },
    removeRelative(index) {
      this.relatives.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;

  th, td {
    text-align: left;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  th {
    font-size: 12px;
    color: #258bf5;
  }

  /* scrollable tbody if content overlaps height */
  tbody {
    height: 150px;
    overflow: auto;
    display: block;
  }
  tr {
    display:table;
    width:100%;
    table-layout: fixed;
  }
}
</style>